<template>
  <div :class="classObj" class="app-wrapper app-wrapper-new-style">
        <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <navbar />
    <div class="main-container">
      <div :class="{'fixed-header':fixedHeader}" />
      <app-main />
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Navbar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
// import Breadcrumb from '@/components/Breadcrumb'
import pathToRegexp from 'path-to-regexp'
export default {
  name: 'Layout',
  components: {
    Navbar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data() {
    return {
        levelList:[],
        active:"/"
      }
    
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]
      if (!this.isDashboard(first)) {
        matched = [{ path: '/', meta: { title: '' }}].concat(matched)
      }
      const list = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
       const url=this.$route.path
       this.active=url
       
       if(this.levelList.length==0){
         
         this.levelList.push(list[1])
       }else{
        for(var i =0;i<this.levelList.length;i++){
        
          if(this.levelList[i].path==list[1].path){  
            this.active=list[1].name
            return 
          }
           
       }
       this.active=list[1].name
       this.levelList.push(list[1])//路由列表
      
      
       }
      
      
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    jump(data,name) {
      console.log(name)
      this.active=name
      this.$router.push({path:data})
    },
    handleClose(index,tag) {
      if(this.levelList.length>1){
         for(var i=0;i<=this.levelList.length;i++){
          if(this.levelList[i].name==tag){
            if(i==0){
              this.active=this.levelList[1].name
              this.$router.push({path:this.levelList[1].path})
            }else{
              this.active=this.levelList[i-1].name
              this.$router.push({path:this.levelList[i-1].path})
            }
            this.levelList.splice(i,1)
          }
         }
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";
.navbar {
  background-color: #1C2B36;
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
#app .sidebar-container {
  top: 59px;
}
.menu {
  margin-left: 11px;
  margin-top: 10px;
}
.el-header {
  padding: 0px;
}
.el-tag{
  color:rgba(0,0,0,0.25);
  background-color:#f5f5f5;
  border:none;
  border-radius:4px 4px 0px 0px;
  
}
/deep/.el-tag .el-tag__close,{
  color:rgba(0,0,0,0.25)!important;
}
/deep/.el-tag .el-tag__close:hover{
  background-color:#f5f5f5;
}
.Active{
  background-color:#fff;
  color:#FFA940;
}
.menu{
  margin-left:15px;
}
</style>
